import heroImgDesktop from 'assets/images/productPages/d-accessories-collection-hero.jpg';
import heroImgMobile from 'assets/images/productPages/m-accessories-collection-hero.jpg';
import haircareImgDesktop from 'assets/images/productPages/prose-model-showering-desktop.jpg';
import haircareImgMobile from 'assets/images/productPages/prose-model-showering-mobile.jpg';
import skincareImgDesktop from 'assets/images/productPages/prose-model-using-custom-skincare-desktop.jpg';
import skincareImgMobile from 'assets/images/productPages/prose-model-using-custom-skincare-mobile.jpg';

export const accessoriesCollection = {
  hero: {
    imageDesktop: heroImgDesktop,
    imageMobile: heroImgMobile,
    imageTablet: heroImgDesktop,
    color: 'noir',
    headline: 'Prose accessories',
  },
  seoBlurb: {
    headline: 'Self care meets sustainability',
    subHead:
      'From award-winning, custom hair brushes to clean, fine-fragrance candles, our accessories are the perfect complement to your personalized beauty routine. Each is made with sustainability and luxury in mind as a treat for skin, hair, and senses.',
  },
  featured: [
    {
      imgAlt: 'Prose model using custom skincare',
      imgMobile: skincareImgMobile,
      imgDesktop: skincareImgDesktop,
      title: 'Discover custom skincare',
      ctaLabel: 'explore skincare',
      url: '/pages/skincare',
      dataFrom: 'explore-skincare',
      dataClick: 'PLP-upsell',
    },
    {
      imgAlt: 'Prose model showering with custom haircare',
      imgMobile: haircareImgMobile,
      imgDesktop: haircareImgDesktop,
      title: 'Browse custom haircare',
      ctaLabel: 'explore haircare',
      url: '/products/haircare',
      dataFrom: 'explore-skincare',
      dataClick: 'PLP-upsell',
    },
  ],
};
